/* AII — Account menu dropdown: accessibile da tastiera (aria-expanded, Esc, frecce, click-outside). */
(function () {
  function init(root) {
    if (root.dataset.aiiAcctInit === '1') return;
    root.dataset.aiiAcctInit = '1';

    var trigger = root.querySelector('[data-aii-acct-trigger]');
    var menu = root.querySelector('[data-aii-acct-menu]');
    if (!trigger || !menu) return;

    function items() {
      return Array.prototype.slice.call(menu.querySelectorAll('[role="menuitem"]'));
    }

    function open() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick, true);
      var first = items()[0];
      if (first) first.focus();
    }

    function close(focusTrigger) {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, true);
      if (focusTrigger) trigger.focus();
    }

    function onDocClick(e) {
      if (!root.contains(e.target)) close(false);
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) open();
      else close(false);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) {
        e.stopPropagation();
        close(true);
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var list = items();
        if (!list.length) return;
        if (menu.hidden) open();
        e.preventDefault();
        var i = list.indexOf(document.activeElement);
        var n = e.key === 'ArrowDown' ? i + 1 : i - 1;
        if (n < 0) n = list.length - 1;
        if (n >= list.length) n = 0;
        list[n].focus();
      }
    });
  }

  function boot() {
    document.querySelectorAll('aii-account-menu').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
